<template>
  <section
    class="has-background-light state-selector font-rubik text-[#334155]"
  >
    <div class="flex justify-center bg-themeComponentBg-light pb-[112px] pt-[88px] lg:pt-0 ">
      <div class="mx-5 max-w-[1216px] min-h-[569px] flex flex-col gap-[80px]">
        <aside class="h-[167px]">
          <div class="flex flex-col h-full justify-evenly">
            <h4 class="title">
              Explore Shipping Containers<br />Available in Your State
            </h4>

            <p>
              Select your state to access service details and container types
              available locally.
            </p>
          </div>
        </aside>

        <div class="flex flex-wrap gap-x-10 gap-y-5">
          <ul
            v-for="(column, cIdx) in columns"
            :key="cIdx"
            class="flex flex-col gap-y-5 shrink-0"
          >
            <li v-for="state in column" :key="state.id">
              <a
                :href="`/service-areas/${state.abrv.toLowerCase()}`"
                class="block transition-colors duration-200 hover:text-blue-600 min-w-[140px] sm:min-w-0"
              >
                {{ state.name }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'StateSelect',
  props: {
    states: {
      type: Array,
      required: true
    }
  },
  computed: {
    columns() {
      const chunks = []
      for (let i = 0; i < this.states.length; i += 6) {
        chunks.push(this.states.slice(i, i + 6))
      }
      return chunks
    }
  }
}
</script>

<style scoped>
.service-areas-title {
  font-size: 48px;
  line-height: 58px;
  letter-spacing: -4%;
}
.service-areas-subtitle {
  font-size: 18px;
  line-height: 27px;
  letter-spacing: -2%;
}
</style>
